import { FieldCreator } from "./FieldCreator";

export const field = new FieldCreator();
